<template>
  <div id="cs">
    <div class="columns is-fullheight colorsidebar">
      <div class="column is-2">
        <div id="sidebar">
          <template>
            <b-menu class="is-sidebar-menu">
            <h1 class="subtitle">{{ activeBiro.nama_biro }}</h1>
            <b-menu-list label="Menu">
              <!-- <b-menu-item icon="view-dashboard" label="Dashboard"></b-menu-item>               -->
              <b-menu-item
                icon="school"
                label="Data Sekolah"
                tag="router-link"
                :to="{ name: 'BerandaSekolah' }">
              </b-menu-item>
              <b-menu-item
                expanded
                icon="account-star"
                label="Data Guru"
                tag="router-link"
                :to="{ name: 'BerandaGuru' }">
              </b-menu-item>
              <b-menu-item
                icon="account-multiple"
                label="Data Siswa"
                tag="router-link"
                :to="{ name: 'BerandaSiswa' }">
              </b-menu-item>
               <!-- <b-menu-item
                icon="account-circle"
                label="Assign Regu"
                tag="router-link"
                :to="{ name: 'BerandaRegu' }">
              </b-menu-item> -->
               <b-menu-item
                icon="account-multiple-plus"
                label="Data Anggota Biro"
                tag="router-link"
                :to="{ name: 'BerandaPersonil' }">
              </b-menu-item>
              <b-menu-item
                icon="book-multiple"
                label="Unggah Data Excel"
                tag="router-link"
                :to="{ name: 'BerandaLaporan' }">
              </b-menu-item>
              <!-- <b-menu-item
                icon="file-powerpoint-box"
                label="Assign Paket"
                tag="router-link"
                :to="{ name: 'ListPaket' }">
              </b-menu-item> -->
              <!-- v-if="activeUser.role === 'Super Admin'" -->
              <b-menu-item
                v-if="activeUser.role === 'Super Admin'"
                icon="book"
                label="Sertifikat"
                tag="router-link"
                :to="{ name: 'BerandaSertifikat' }">
              </b-menu-item>
              <!-- <b-menu-item
                v-if="activeUser.role === 'Super Admin'"
                icon="newspaper"
                label="Blog & Podcast"
                tag="router-link"
                :to="{ name: 'NewBlog' }">
              </b-menu-item> -->
              <b-menu-item
                icon="newspaper"
                label="Blog"
                tag="router-link"
                :to="{ name: 'BerandaBlogBiro' }">
              </b-menu-item>
               <b-menu-item
                icon="account-switch"
                label="Event"
                tag="router-link"
                :to="{ name: 'BerandaPelatihan' }">
              </b-menu-item>
              <!-- <b-menu-item
                icon="account-multiple-plus"
                label="Daftar Kehadiran"
                tag="router-link"
                :to="{ name: 'DaftarKehadiran' }">
              </b-menu-item> -->
              
            </b-menu-list>
            <b-menu-list label="Actions">
              <b-menu-item v-show="activeUser.role === 'Koordinator Biro'"
                icon="logout"
                label="Logout"
                @click="confirmLogout()"
              ></b-menu-item>
               <b-menu-item v-show="activeUser.role === 'Super Admin'"
                icon="arrow-left-bold"
                label="Back To Admin"
                @click="confirmBackAdmin()"
              ></b-menu-item>
            </b-menu-list>
          </b-menu>
          </template>
        </div>
      </div>

      <div class="column has-background-white-ter is-fullheight" style="overflow-y: scroll">
        <div id="navbar">
          <b-navbar class="has-background-white-ter nav-padding">
            <template slot="end">
              <b-dropdown position="is-bottom-left" append-to-body>
                <a class="navbar-item" slot="trigger" role="button">
                  <span>{{ activeUser.email }}</span>
                  <b-icon icon="menu-down"></b-icon>
                </a>

                <b-dropdown-item custom aria-role="menuitem">
                  Logged as <b>{{ activeUser.role }}</b>
                </b-dropdown-item>
                <!-- <hr class="dropdown-divider">
                <b-dropdown-item value="settings">
                  <b-icon icon="cogs"></b-icon>
                  Settings
                </b-dropdown-item>
                <b-dropdown-item value="logout" aria-role="menuitem" @click="confirmLogout">
                  <b-icon icon="logout"></b-icon>
                  Logout
                </b-dropdown-item> -->
              </b-dropdown>
            </template>
          </b-navbar>
        </div>
        <div id="content">
          <div>

            <router-view activeUser="activeUser" />
            
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import AutoLogout from './AutoLogout.vue'
export default {
  components: { AutoLogout },
  data() {
    return {
     
      activeUser: Object,
      activeBiro: Object,
      isActive: true
    }
  },
  methods: {
    userLogout(){
      this.$session.destroy()
      this.$router.push('/')
    },
    backAdmin(){
      //this.$session.destroy()
      this.$session.remove('biro')
      this.$router.push('/admin/berandabiro')
    },
    confirmLogout(){
      this.$buefy.dialog.confirm({
        title:'Kelola Data',
        message:'Kamu yakin ingin kembali keluar dari sistem ?',
        confirmText:'Ya',
        cancelText:'Batal',
        type:'is-danger',
        hasIcon:true,
        onConfirm:() => this.userLogout()
      })
    },
    confirmBackAdmin(){
      this.$buefy.dialog.confirm({
        title:'Kelola Data',
        message:'Kamu yakin ingin kembali ke menu admin ?',
        confirmText:'Ya',
        cancelText:'Batal',
        type:'is-danger',
        hasIcon:true,
        onConfirm:() => this.backAdmin()
      })
    }
  },
  mounted(){
    if(this.$session.exists()){
      this.activeBiro = this.$session.get('biro')
      this.activeUser = this.$session.get('user')
    }
  }
}
</script>

<style scoped>
.colorsidebar {
  background-color: #E5E5E5;
  /* background-color: #2196F3; */
}

.is-fullheight.columns {
    height: calc(100vh - ( 0rem - .75rem ) );
}

/* .title-nama-data {
  margin: 20px 10px;
} */

.is-sidebar-menu {
  margin: 10px 0 0 10px;
}
</style>